import { AuthoritiesLogos } from './authoritiesLogos';

export default [
  {
    altText: 'Antrim Logo',
    logo: AuthoritiesLogos.antrim,
    href: 'https://antrimandnewtownabbey.gov.uk/',
    width: { base: '7.75rem', md: '10.25rem', lg: '11.25rem' },
    height: { base: '2.25rem', md: '3rem', lg: '3.5rem' },
  },
  {
    altText: 'Ards Logo',
    logo: AuthoritiesLogos.ards,
    href: 'https://www.ardsandnorthdown.gov.uk/',
    width: { base: '4rem', md: '4rem', lg: '4.5rem' },
    height: { base: '2.75rem', md: '3rem', lg: '3.5rem' },
  },
  {
    altText: 'Armagh Logo',
    logo: AuthoritiesLogos.armagh,
    href: 'https://www.armaghbanbridgecraigavon.gov.uk/',
    width: { base: '6.75rem', md: '7rem', lg: '8rem' },
    height: { base: '2.75rem', md: '3rem', lg: '3.5rem' },
  },
  {
    altText: 'Belfast',
    logo: AuthoritiesLogos.belfast,
    href: 'https://www.belfastcity.gov.uk/',
    width: { base: '8.5rem', md: '10.5rem' },
    height: { base: '2.75rem', md: '3.5rem' },
  },
  {
    altText: 'Causeway Logo',
    logo: AuthoritiesLogos.causeway,
    href: 'https://www.causewaycoastandglens.gov.uk/',
    width: { base: '9rem', md: '11rem', lg: '10.5rem' },
    height: { base: '2.75rem', md: '3.5rem', lg: '3.5rem' },
  },
  {
    altText: 'Derry Logo',
    logo: AuthoritiesLogos.derry,
    href: 'https://www.derrystrabane.com/',
    width: { base: '6.25rem', md: '7.25rem', lg: '6.75rem' },
    height: { base: '2.75rem', md: '3.5rem', lg: '3.25rem' },
  },
  {
    altText: 'Fermanagh Logo',
    logo: AuthoritiesLogos.fermanagh,
    href: 'https://www.fermanaghomagh.com/',
    width: { base: '9rem', md: '11rem', lg: '11.25rem' },
    height: { base: '2.5rem', md: '3.25rem' },
  },
  {
    altText: 'LCCC Logo',
    logo: AuthoritiesLogos.lccc,
    href: 'https://www.lisburncastlereagh.gov.uk/',
    width: { base: '3rem', md: '3.75rem', lg: '3.75rem' },
    height: { base: '2.5rem', md: '3.5rem', lg: '3.25rem' },
  },
  {
    altText: 'Mid East Antrim Logo',
    logo: AuthoritiesLogos.midEastAntrim,
    href: 'https://www.midandeastantrim.gov.uk/',
    width: { base: '6.5rem', lg: '8.75rem' },
    height: { base: '2.5rem', md: '3.25rem' },
  },
  {
    altText: 'Newry Logo',
    logo: AuthoritiesLogos.newry,
    href: 'https://www.newrymournedown.org/',
    width: { base: '6.75rem', md: '7.25rem', lg: '7rem' },
    height: { base: '3rem', md: '3.25rem' },
  },
  {
    altText: 'DFI Logo',
    logo: AuthoritiesLogos.dfi,
    href: 'https://www.infrastructure-ni.gov.uk/',
    width: { base: '8.75rem', md: '11.75rem', lg: '11.25rem' },
    height: { base: '2rem', md: '3rem', lg: '3.25rem' },
  },
];
